import React from 'react';
import { 
  LogoContainer, 
  LogoImage, 
  MainTitle, 
  SubTitle 
} from '../StyledComponents';
import { HeaderSectionProps } from '../types';

const HeaderSection: React.FC<HeaderSectionProps> = ({ logo }) => {
  return (
    <>
      <LogoContainer>
        <LogoImage src={logo} alt="IQ Logo" />
        <MainTitle>Generate</MainTitle>
      </LogoContainer>

      <SubTitle>
        Generate compelling emails for your dealership offers and inventory with AI-powered content creation
      </SubTitle>
    </>
  );
};

export default HeaderSection;
